import './Profile.css'
import LogoutArea from "./LogoutArea"
import { Button } from 'react-bootstrap'
import DeleteAccount from './DeleteAccount'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { APP_DIRECTORY } from '../SystemVariables'

const Profile = (props) => {
    const [deleteAccount, setDeleteAccount] = useState(false)

    if(deleteAccount) {
        return <DeleteAccount cancel={()=>{setDeleteAccount(false)}} accessToken={props.accessToken}/>
    } else {
        return(<div className="profile">
            <h1>{props.username}</h1>
            <p><Link to={`${APP_DIRECTORY}/`}>To dashboard</Link></p>
            <p><LogoutArea accessToken={props.accessToken}/></p>
            <div className="deleteAccountArea">
                <Button variant="danger" onClick={()=>{setDeleteAccount(true)}}>Delete Account</Button>
            </div>
        </div>)
    }
}

export default Profile